import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class XlsExportService {

  constructor() { }


	public exportCsv(list, keys, name_file, header?){
		var a:any = list.map(el => {
			return  _.pick(el, keys);
		});
		if (header) {
			a.unshift(header)
		}

		return this.exportAsExcelFile(a, name_file);
	}

  public exportAsExcelFile(json: any[], excelFileName: string) {  
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {skipHeader:true});
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    return this.getPendingFileExcel(excelBuffer, excelFileName);
  }

  private getPendingFileExcel(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });

    return  { 
			'fileName': fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION,
			'action': 'download',
			'taskId': Date.now() + Math.random(), 
      'status': 'pending',
      'isFrontReport': true,
      'info':{
        'data': data
      }
    };
  }

}

